module.exports = __webpack_public_path__ + "media/img/calendar/calendar-check-ef421cb9ea533c9ff847ceb5c4c335b4.png";